require('./sctNav.scss');

const $inject = [];

const sctNav = {
  controller: 'lbNavCtrl as vm',
  template: require('./sctNav.html')
};

sctNav.$inject = $inject;

export default sctNav;


// WEBPACK FOOTER //
// ./src/components/sct/sctNav/sctNav.js